import { Box, FormControl, InputLabel, SelectChangeEvent } from "@mui/material";
import { Menu, MenuItem, Select } from "@mui/material";
import { filterMenuStyles } from "../../components/TracksPageComponents/styles";
import { FilterAndSortButton } from "../../components/TracksPageComponents/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";
import { projectFilterMenuStyles, styles } from "./styles";
import { ProjectFileFilterMenuProps } from "./types";

export const ProjectFileFilterMenu: React.FC<ProjectFileFilterMenuProps> = ({
  filter,
  setFilter,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <FilterAndSortButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget as HTMLElement)}
        sx={styles.filterButton}
      >
        <FilterListIcon sx={{ margin: "10px" }} />
        Filters
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        sx={filterMenuStyles.menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Box sx={projectFilterMenuStyles.menuBox}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select type</InputLabel>
            <Select
              value={filter}
              label="Select type"
              fullWidth
              onChange={(event: SelectChangeEvent) => {
                setFilter(event.target.value as string);
              }}
            >
              <MenuItem value={""}>Select</MenuItem>
              <MenuItem value={"image"}>Image</MenuItem>
              <MenuItem value={"video"}>Video</MenuItem>
              <MenuItem value={"audio"}>Audio</MenuItem>
              <MenuItem value={"pdf"}>PDF</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Menu>
    </>
  );
};
